export function transformDate(date?: string): string {
  if (date) {
    return new Date(date).toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  }
  return "";
}

export const validDateFormat = /((0[1-9]|1[0-2])[/]([0-2]{1}[0-9]{1}|3[0-1]{1})[/][0-9]{4})/;
